import React, { useCallback } from 'react';
import useCompose from '../../../../../../hooks/useCompose';
import useContext from '../../../../../../hooks/useContext';
import {
  ActionItem,
  ActionList,
  ActionMain,
} from '../../../../../../styled/FilterSortPanel/wrappers';
import InputCheckbox from '../../../../../../styled/InputCheckbox';
import { CategoryContext } from '../../../Providers/CategoryProvider';
import ListItemWrapper from './ListItemWrapper';

interface IOption {
  label: string;
  onChange: (value: Sorting) => void;
  selected: boolean;
  value: Sorting;
}

const Option = ({ label, onChange, selected, value }: IOption) => {
  const change = useCallback(() => {
    onChange(value);
  }, [onChange, value]);

  return (
    <ActionItem>
      <ActionMain>
        <InputCheckbox id={value || 'reset'} onChange={change} checked={selected} type="radio">
          {label}
        </InputCheckbox>
      </ActionMain>
    </ActionItem>
  );
};

interface ISorting {
  onSort?: () => void;
  panelFocus: string | undefined;
}

const defaultCallback = () => undefined;

const getSortDisplayName = (sorting: Sorting) => {
  switch (sorting) {
    case 'az':
      return 'Namn, A-Ö';
    case 'za':
      return 'Namn, Ö-A';
    case 'lowprice':
      return 'Lägst pris';
    case 'highprice':
      return 'Högst pris';
    case 'discountpercentage':
      return 'Högst rabatt';
    default:
      return 'Popularitet';
  }
};

const Sort = ({ onSort = defaultCallback, panelFocus }: ISorting) => {
  const { sort, sorting } = useContext(CategoryContext);

  const doSort = useCompose(sort, onSort);

  return (
    <ListItemWrapper
      title="Sortering"
      highlightValue={getSortDisplayName(sorting)}
      defaultOpen={panelFocus === 'sort'}>
      <ActionList>
        <Option onChange={doSort} value="" label="Popularitet" selected={!sorting} />

        <Option
          onChange={doSort}
          value="lowprice"
          label="Lägst pris"
          selected={sorting === 'lowprice'}
        />

        <Option
          onChange={doSort}
          value="highprice"
          label="Högst pris"
          selected={sorting === 'highprice'}
        />

        <Option onChange={doSort} value="az" label="Namn, A-Ö" selected={sorting === 'az'} />

        <Option onChange={doSort} value="za" label="Namn, Ö-A" selected={sorting === 'za'} />

        <Option
          onChange={doSort}
          value="discountpercentage"
          label="Högst rabatt"
          selected={sorting === 'discountpercentage'}
        />
      </ActionList>
    </ListItemWrapper>
  );
};

export default Sort;
